// vendor modules
import React from 'react'
import PropTypes from "prop-types"

import SearchifyWrapper from 'search-new/components/Searchify/SearchifyWrapper'
// this is a thin wrapper around selects that renders a select in most
// cases, but if it's a select holding a searchify submission, it renders
// something else in its place
export default function SelectOrEditSelection(props) {

    const renderEditBox = () => (
        <div className='launch-custom-selection'>
            <SearchifyWrapper searchifyConfigs={props.searchifyConfigs}>
                <div className='launch-custom-selection-message'>
                    {
                        props.value.searchifyCount
                            ? `Edit ${props.value.searchifyCount.toLocaleString()} Selections`
                            : `Edit Selections`
                    }
                </div>
            </SearchifyWrapper>
            <div
                onClick={props.clearSearchifySelection}
                className='clear-custom-selection-message'
            >
                ×
            </div>
        </div>
    )

    const SelectComponent = props.selectComponent
    const usingEditBox = props.value && props.value.querysetList && props.value.querysetList.length
    const addedIds = props.value.addedIds

    return usingEditBox
        ? renderEditBox()
        : <SelectComponent
            {...props}
            value={props.multi ? addedIds : addedIds && addedIds[0]}
        />
}

SelectOrEditSelection.propTypes = {
    value: PropTypes.object,
    searchifyConfigs: PropTypes.object.isRequired,
    clearSearchifySelection: PropTypes.func.isRequired,
    selectComponent: PropTypes.func.isRequired,
    multi: PropTypes.bool,
}

SelectOrEditSelection.defaultProps = {
    multi: true,
}
